// Text-wrap/white-space styling control — plan-v3.md Step 4. Any schema
// field with `wrapControl: true` gets an implicit `<key>Wrap` companion prop
// (e.g. `headlineWrap`), following the exact same convention as
// `imagePicker`'s `<key>Source` companion prop. The wrap value itself is a
// plain string, never translatable — the same wrap behavior applies
// regardless of which language's text is currently showing.

export const WRAP_OPTIONS = [
    { value: "normal",     label: "Normal wrap" },
    { value: "nowrap",     label: "No wrap" },
    { value: "break-word", label: "Break word" },
];

// CSS this maps to — kept as one shared lookup so admin preview and any
// future consumer compute the identical style object from the same source.
export const WRAP_STYLE_BY_VALUE = {
    normal:      { whiteSpace: "normal" },
    nowrap:      { whiteSpace: "nowrap" },
    "break-word": { whiteSpace: "normal", overflowWrap: "break-word" },
};

export function resolveWrapStyle(value) {
    return WRAP_STYLE_BY_VALUE[value] || WRAP_STYLE_BY_VALUE.normal;
}

// Per-field default overrides for existing published rows with no
// `<key>Wrap` value at all — must match whatever CSS behavior that field
// already rendered before this control existed, so nothing visually shifts
// the moment this ships. Keyed by `${componentKey}.${field}` — NOT by field
// name alone, since e.g. hero's `ctaText` has no pre-existing wrap style
// while navbar's `ctaText` does (its authenticated-state button already
// renders `truncate`/nowrap today); a bare `ctaText` key would incorrectly
// apply navbar's override to hero too. Every field/key not listed here
// defaults to "normal".
export const WRAP_DEFAULT_OVERRIDES = {
    "navbar.ctaText": "nowrap",   // authenticated-state button already renders `truncate` (nowrap) today
    "navbar.label":   "nowrap",   // navLinks[].label — matches its existing whiteSpace:"nowrap" today
};

export function resolveWrapDefault(componentKey, field) {
    return WRAP_DEFAULT_OVERRIDES[`${componentKey}.${field}`] || "normal";
}
